"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lws_aws_codeCommit_repoistory = exports.aws_codeCommit_repositories = void 0;
const awsCodeCommitUrlBase = 'git-codecommit.ap-southeast-2.amazonaws.com/v1/repos/';
exports.aws_codeCommit_repositories = {
    b001: { repo: `ssh://${awsCodeCommitUrlBase}b001`, directory: './b001' },
    c021: { repo: `ssh://${awsCodeCommitUrlBase}c021`, directory: './c021' },
    v001: { repo: `ssh://${awsCodeCommitUrlBase}v001`, directory: './v001' },
    v013: { repo: `ssh://${awsCodeCommitUrlBase}v013`, directory: './v013' },
    v015: { repo: `ssh://${awsCodeCommitUrlBase}v015`, directory: './v015' },
    v016: { repo: `ssh://${awsCodeCommitUrlBase}v016`, directory: './v016' },
    v017: { repo: `ssh://${awsCodeCommitUrlBase}v017`, directory: './v017' },
    v020: { repo: `ssh://${awsCodeCommitUrlBase}v020`, directory: './v020' },
    v021: { repo: `ssh://${awsCodeCommitUrlBase}v021`, directory: './v021' },
    v022: { repo: `ssh://${awsCodeCommitUrlBase}v022`, directory: './v022' },
    // these appear to have been manually added, and the names clash
    // v010: { repo: `ssh://${awsCodeCommitUrlBase}v010`, directory: './v010' },
    // v023: { repo: `ssh://${awsCodeCommitUrlBase}v023`, directory: './v023' },
    v024: { repo: `ssh://${awsCodeCommitUrlBase}v024`, directory: './v024' },
    i301: { repo: `ssh://${awsCodeCommitUrlBase}i301`, directory: './i301' },
    ssac: { repo: `ssh://${awsCodeCommitUrlBase}ssac`, directory: './ssac' },
    x000: { repo: `ssh://${awsCodeCommitUrlBase}x000`, directory: './x000' },
};
exports.lws_aws_codeCommit_repoistory = { repo: `ssh://${awsCodeCommitUrlBase}lws`, directory: './' };
